import { createDialogStore } from 'store/createDialogStore';

export const useIntegrationSelectDialog = createDialogStore();
